import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const companyLocaleModule: LocaleModule = {
  name: "company",
  messages: { en: en, it: it },
};
